// extracted by mini-css-extract-plugin
export default {"heading":"subsection_heading__NKa6I","instructions":"subsection_instructions__sBd7A","element":"subsection_element__FWUov"};